// eslint-disable-next-line import/prefer-default-export
export const ATS_ES = {
  // Common
  Close: 'Cerrar',
  Save: 'Guardar',

  // header
  AddColumn: 'Agregar columna',
  Notifications: 'Notificaciones',
  tooltipNotifications: 'Notificar al inicio del proceso de cada candidato',
  tooltipSearch: 'Buscar un candidato',
  // Export excel
  numberEmpty: 'Sin número telefónico',
  emailEmpty: 'Sin email',
  Average: 'Promedio',
  AverageEmpty: 'No tiene cuestionario',
  cvEmpty: 'Sin cv',
  Unrated: 'Sin calificar',
  FirstName: 'Nombres',
  LastName: 'Apellidos',
  Email: 'Email',
  EmailSecondary: 'Email secundario',
  Date: 'Fecha',
  Qualification: 'Calificación',
  PhoneNumber: 'Número telefónico',
  SecondaryNumber: 'Número secundario',
  DescriptionEmpty: 'Sin descripción',
  Description: 'Descripción',
  cvWithBias: 'Cv con sesgos',
  cvWithoutBias: 'Cv sin sesgos',
  Comments: 'Comentarios',
  CommentsEmpty: 'Sin comentarios',

  // Modal search candidates
  allcolumns: 'Todas las columnas',
  searchCandidates: 'Buscar por nombre de candidato',
  cancelSearch: 'Cancelar',

  // modalImport
  ImportHeader: 'Importar Candidatos',
  ImportExcell: 'Importar Excell',
  CandidateFirstName: 'Nombre:',
  CandidateLastName: 'Apellidos:',
  CandidateEmail: 'Correo:',
  CandidatePhone: 'Teléfono:',
  Cv: 'CV:',
  Accept: 'Aceptar',

  // modalOwners
  Owners: 'Encargados',
  OwnersHeader: 'Agregar encargados',
  Recruiter: 'Reclutador',
  User: 'Usuario',
  AddOwnersMessage: 'Se actualizarán los encargados de la vacante.',

  // modalCriteria
  CriteriaHeader: 'Criterios',
  CriteriaMessage1: 'Agregar criterios a evaluar',
  CriteriaMessage2: 'Serán visibles en toda la vacante',
  AddCriteriaConfirmation: 'Este criterio no podrá ser modificado, ¿quiere continuar?',
  CriteriaDeleteConfirmation:
    '¿Está seguro de eliminar este criterio? Una vez eliminado, los promedios se volverán a calcular.',
  ChangeTemplateConfirmation: 'Si cambia la plantilla las calificaciones de la plantilla anterior se perderán',
  AddTemplate: 'Agregar plantilla',
  CriterionName: 'Criterio',
  AddCriterion: 'Agregar criterio',
  tooltipAddCriterion: 'Agregar criterio a la vacante',
  WeightInvalidValue: 'El valor del peso debe ser entre 0.1 y 10',
  MustNameCriterion: 'You must name the criterion',

  // modalDrag
  modalDragHeader: '¿A dónde movemos al candidato?',
  MessageMagic1: 'Determina el % de respuestas correctas que debe tener el postulante para moverlo de la columna ',
  MessageMagic2: ' a la colummna seleccionada.',
  WantToAddEmail: '¿Deseas agregar un correo?',
  SelectColumn: 'Seleccionar columna',
  MoveThemAll: 'Mover todos',
  MessageEmptyQuestions: 'Para poder usar las',
  MessageSecondEmptyQuestions: 'necesita asignar un bloque de preguntas a la vacante',
  MessageButtonEmpty: 'Asignar preguntas',
  No: 'No',
  Yes: 'Sí',
  Cancel: 'Cancelar',
  Add: 'Guardar',
  Saved: 'Guardado',
  AddEmailMessage: 'Esta función te permite editar el mail que se enviará a los candidatos en la columna: ',
  CandidateName: 'Nombre del postulante: ',
  CompanyName: 'Nombre de la empresa: ',
  VacancyName: 'Nombre de la vacante: ',
  RedactEmail: 'Redacte su email',
  Subject: 'Asunto',
  CorrectAnswers: 'Respuestas Correctas',
  WrongAnswers: 'Respuestas Incorrectas',
  RangeAnswers: 'Respuestas de Rango',
  ClosedAnswers: 'Respuestas Cerradas',
  MultipleChoice: 'Respuestas de Opción múltiple',
  SelectCondition: 'Seleccione la condición',
  SelectType: 'Selecciona tipo de pregunta',
  InitialValue: 'Valor inicial',
  FinishValue: 'Valor final',
  TrueAnswers: 'Respuesta: SI',
  FalseAnswers: 'Respuesta: NO',
  SelectQuestions: 'Selecciona las preguntas',
  EqualTo: 'Igual a',
  LessOrEqual: 'Menor o igual que ',
  GreaterOrEqual: 'Mayor o igual ',
  ColumnCandidate: 'Nuevos Candidatos',
  TextTab: 'Regla',
  Notify: 'Notificar Candidatos',
  DeleteRule: 'Eliminar regla',
  AddRule: 'Agregar Regla',
  MessagePlaceholder:
    'Estimado {CANDIDATE} este es un correo automatico para informarte que sigues activo en el proceso de selección',
  MessageErrorColumns: 'Debe de seleccionar la columna destino',
  MessageErrorPercentageEmpty: 'El porcentaje no puede quedar vacio',
  MessageErrorPercentageZero: 'El porcentaje debe de ser mayor a 0',
  MessageErrorCondition: 'Debe seleccionar una condición',
  MessageErrorValueRange: 'El valor debe de estar entre 1 y 10',
  MessageErrorClosedAnswers: 'Debe seleccionar una pregunta',
  MessageErrorRangeInitialValue: 'Debe asignar un valor inicial',
  MessageErrorRangeFinishValue: 'Debe asignar un valor final',
  MessageErrorSubject: 'El asunto no puede quedar vacío',
  MessageErrorMessage: 'El mensaje no puede quedar vacío',
  MessageConnector: 'en la regla',
  MessageConnectorTabs: 'en el texto',
  MessageSuccessMagicCreate: 'Magic Action creada',
  // popupColumn
  Manage: 'Administrar',
  EditName: 'Editar nombre',
  Delete: 'Eliminar',
  AddCandidate: 'Agregar candidato',
  Multiselect: 'Multiselección',
  CloseMuultiselect: 'Cerrar multiselección',
  // popper
  ExportCandidates: 'Exportar candidatos',
  ImportCandidates: 'Importar candidatos',
  ScoreCriteria: 'Criterios de calificación',
  AddOwners: 'Agregar encargados',
  MagicActions: 'Magic actions',
  EditVacancy: 'Editar Vacante',
  Analitics: 'Analíticas de la vacante',

  // modalCustomEmail
  CustomEmailHeader: 'Personalizar email',

  // manageColumnsOwners
  ManageColumnOwnersHeader: 'Administrar encargados de columna',
  ManageColumnOwnersQuestion: '¿Quiénes son los encargados de esta columna?',
  SelectAll: 'Seleccionar todos',
  NameOwners: 'Nombrar encargados',
  DeleteFromOwners: 'Eliminar de encargados',
  WhoToNotify: '¿A quién notificamos por Slack?',
  placeholderChooseUsers: 'Sellecione usuarios o canales',
  DidYouKnow:
    '¿Sabías que...? Puedes notificar a tus colaboradores a través de Slack, para ello requerimos que vincules tu cuenta de Slack y después vuelvas a intentarlo.',
  Integrate: 'Integrar',

  // modalAddCandidate
  NewCandidate: 'Nuevo candidato',
  placeholderFirstName: 'Nombre',
  placeholderLastName: 'Apellidos',
  placeholderEmail: 'Correo',
  placeholderPhone: 'Teléfono',
  SelectCv: 'Seleccione un cv (Opcional)',
  GeneratedId1: 'Hemos generado el ID: ',
  GeneratedId2: ' para su archivo',
  placeholderTextArea: 'Escriba algo sobre el candidato',
  AddPhoneSecondary: 'Número secundario',
  AddEmailSecondary: 'Correo secundario',

  // modal Reject Candidate
  RejectApplicantHeader: '¿Cómo deberíamos notificarle?',
  RejectApplicantMessage1: 'Está rechazando al candidato ',
  AcceptApplicantMessage1: 'Está acceptando al candidato ',
  RejectApplicantMessage2: ' de esta vacante',
  Customize: 'Personalizar',
  DoNotNotify: 'No notificar',
  Template: 'Plantilla',

  // droppable
  NewName: 'Nuevo nombre',
  Unnamed: 'Sin nombre',
  PersonalFilter1: 'Filtro personal 1',
  PersonalFilter2: 'Filtro personal 2',
  RejectedWillBeNotified: 'Se enviará un correo mencionando su rechazo',
  NewCandidates: 'Nuevos candidatos',
  Accepted: 'Aceptados',
  Rejected: 'Rechazados',

  // magic actions
  NoMagicYet: 'No se han agregado Magic Actions',
  tooltipEditMagic: 'Editar Magic Action',
  DeleteMagic: 'Eliminar Magic Action',
  Move: 'Pasar a otra columna',
  DeleteConfirmation: '¿Está seguro de eliminar esta Magic Action?',
  CannotBeDone: 'Esta acción no se puede realizar',
  ImSure: 'Estoy seguro',
  moveRule: 'Mover regla',

  // Modal Rechazar Candidatos
  RejectCandidatesHeader: 'Rechazar candidatos',
  AreYouSureToReject: '¿Está seguro que quiere rechazar a estos candidatos?',
  YouWantToNotifyThem: '¿Deberíamos notificarles?',

  // Multiselect
  Column: 'Columna',
  Done: 'Listo',

  // NotificationManager
  YouHaveToSelect: 'Seleccione una columna y al menos un candidato',
  ComingSoon: 'Próximamente podrá agregar sus propios candidatos en el AtsJsx',
  InvalidName: 'Nombre inválido',
  CannotManipulate: 'Esta columna no puede manipularse',
  BambooSuccess: 'Información del postulante transferida exitosamente a BambooHR',
  BambooError: 'No fue posible transferir la información del postulante a BambooHR',

  // Test
  addTest: 'Agregar test',
  statusTest: 'Estatus',
  nameTest: 'Nombre',
  dateTest: 'Fecha',
  actionsTests: 'Acciones',
  emptyTest: 'No hay información para mostrar',
  selecTemplate: '¿Deseas agregar una plantilla o crear una nueva?',
  createNewTest: 'Crear nueva',
  cancelTest: 'Cancelar',
  sendTest: 'Enviar',
  searchTemplate: 'Buscar plantillas',
  selectedTest: 'Seleccionar',
  sendTestTitle: 'Envía pruebas al postulante con límite de tiempo',
  nameCompleteTest: 'Nombre de la prueba',
  typeTest: 'Prueba',
  instructionsTests: 'Instrucciones',
  timeTest: 'Tiempo de la prueba',
  stopWatchTest: 'Cronómetro de tiempo',
  visibleTest: 'Visible',
  noVisibleTest: 'No visible',
  responseFormat: 'Formato de respuesta',
  urlTest: 'URL',
  fileTest: 'Archivo',
  writeTest: 'Redactar',
  addFile: 'Adjuntar archivo',
  selectFile: 'Seleccionar el archivo',
  placeholderWriteTest: 'Redacción de prueba para el postulante',
  sendNewTest: 'Enviar prueba',
  filesAdjuntos: 'Archivos seleccionados',
  othersFiles: 'Otros archivos',
  deleteFileTest: 'Eliminar archivo',
  backTest: 'Atrás',
  daysTest: 'Días',
  hoursTest: 'Horas',
  minutesTest: 'Minutos',
  introduccionTest: 'Introducción',
  instructionsprevTest: '(Instrucciones previas a la prueba)',

  // MODAL SEND EMAIL
  ChooseEmailProvider: 'Elegir con que proveedor de correo',

  // MODAL REJECT CANDIDATE
  HowNotifyCandidate: '¿Cómo deberíamos notificarle?',
};
